const { __ } = wp.i18n;
import BMediaUpload from "../components/BMediaUpload/BMediaUpload";
import BUnit from "../components/BUnit";
const { TabPanel, Panel, PanelBody, PanelRow, Button, __experimentalUnitControl: UnitControl, TextControl, FormToggle } = wp.components;
const { InspectorControls } = wp.blockEditor;

const Settings = (props) => {
  const {
    props: { attributes, setAttributes },
    currentIndex,
  } = props;
  const { audios, hideDownload, theme, width } = attributes;
  // const [tempWidth, setTempWidth] = useState(typeof width === "object" ? (width.number === 0 ? "100%" : width.number + width.unit) : width);

  if (!audios[currentIndex]) {
    return false;
  }

  const { title, source, artist } = audios[currentIndex];

  const handleList = (property, value) => {
    const newAudios = [...audios];
    newAudios[currentIndex][property] = value;
    setAttributes({ audios: newAudios });
  };

  const handleRemoveItem = (index) => {
    let newAudios = [...audios];
    newAudios = newAudios.filter((item) => newAudios.indexOf(item) != index);
    setAttributes({ audios: newAudios });
  };

  return (
    <InspectorControls style={{ marginBottom: "40px" }}>
      <TabPanel
        className="bPSS"
        activeClass="active-tab"
        tabs={[
          {
            name: "content",
            title: "Content",
            className: "content btTab",
          },
          {
            name: "settings",
            title: "Settings",
            className: "settings btTab",
          },
        ]}
      >
        {(tab) => {
          return (
            <span>
              {tab.name == "content" && (
                <span>
                  <Panel>
                    <PanelBody>
                      <BMediaUpload
                        type={["audio"]}
                        onSelect={(audio) => handleList("source", audio)}
                        label={__("Source", "h5ap")}
                        placeholder={__("Source", "h5ap")}
                        value={source}
                      />
                      <PanelRow>
                        <TextControl placeholder={__("Title", "h5ap")} value={title} onChange={(title) => handleList("title", title)} />
                      </PanelRow>
                      <PanelRow>
                        <TextControl placeholder={__("Artist", "h5ap")} value={artist} onChange={(artist) => handleList("artist", artist)} />
                      </PanelRow>
                      <PanelRow>
                        {/* <Button onClick={() => handleRemoveItem(currentIndex)} variant="primary">
                          {__("Remove", "h5ap")}
                        </Button> */}
                        <div className="d-flex w-full">
                          <Button icon="trash" className="trash" onClick={() => handleRemoveItem(currentIndex)}></Button>
                        </div>
                      </PanelRow>
                    </PanelBody>
                  </Panel>
                </span>
              )}
              {tab.name == "settings" && (
                <span>
                  <Panel>
                    <PanelBody>
                      <PanelRow className="skin">
                        <label className="label">{__("Theme", "h5ap")}</label>
                        <BUnit value={theme} units={["Light", "Dark"]} onChange={(theme) => setAttributes({ theme })} />
                      </PanelRow>
                      <UnitControl
                        value={typeof width === "object" ? `${width.number}${width.unit}` : width}
                        onChange={(width) => setAttributes({ width })}
                        step={1}
                        units={[
                          { label: "px", value: "px", default: 500 },
                          { label: "%", value: "%", default: 100 },
                        ]}
                        isResetValueOnUnitChange={true}
                        label={__("Width", "h5ap")}
                        labelPosition="side"
                      />
                      <PanelRow>
                        <label htmlFor="hideDownload" className="label">
                          {__("Hide Download Button", "h5ap")}
                        </label>
                        <FormToggle id="hideDownload" checked={hideDownload} onChange={() => setAttributes({ hideDownload: !hideDownload })} />
                      </PanelRow>
                    </PanelBody>
                  </Panel>
                </span>
              )}
            </span>
          );
        }}
      </TabPanel>
    </InspectorControls>
  );
};

export default Settings;
